/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const MOUSE_TRAP_ID = 'hideSidebarNavigationMenu';

export const VALUE_SEPERATOR = '_';

// eslint-disable-next-line no-shadow
export enum SidebarNavigationMenuList {
    GUIDE,
    MY_SHOWS,
    SETTINGS,
}
